<template>
  <div class="mt-12">
    <p
      class="tw-block tw-text-center tw-text-eko-orange tw-text-left tw-text-2xl tw--mb-3 tw-font-bold"
    >
      Calculate your Carbon Footprint
    </p>
    <v-alert dense border="left" type="info" class="tw-mt-2">
      Estimate your carbon value before you offset on projects
    </v-alert>
    <router-link to="/offsetter/offset/calculator">
      <v-card class="mx-auto tw-w-2/3 tw-my-2 tw-mt-8">
        <v-card-title
          class="tw-block tw-text-eko-orange tw-text-left tw-text-lg tw--mb-3 tw-font-bold"
          >Carbon Footprint Calculator</v-card-title
        >
        <v-card-text class="">
          <div>
            Estimate the impact of your travel, energy use, farming, feeding,
            and other livelihood activities on the climate. You can estimate
            your carbon footprint through the ECX GHG Calculator. You will
            receive an estimate of emitted CO2 and be given the opportunity to
            Offset these emissions on any or all of the various green projects
            on the Exchange.
          </div>
        </v-card-text>
      </v-card></router-link
    >

    <router-link class="" to="/offsetter/offset/audit">
      <v-card class="mx-auto tw-w-2/3 tw-my-2 tw-mt-8">
        <v-card-title
          class="tw-block tw-text-eko-orange tw-text-left tw-text-lg tw--mb-3 tw-font-bold"
          >Corporate Carbon Audit
        </v-card-title>
        <v-card-text class="">
          <div>
            ECX assists Companies to compute their GHG emissions from their
            business activities and provides strategic measures to reduce
            unavoided emissions. Request today to know your corporate Greenhouse
            Gas emissions.
          </div>
        </v-card-text>
      </v-card>
    </router-link>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
